export default "__VITE_ASSET__3f4e380b__$_#icon-camera__"